<template>
  <div class="topbar-item">
    <div
      class="w-auto d-flex align-items-center px-2 mb-7"
      id="kt_quick_user_toggle"
    >
      <span
        class="font-weight-bold font-size-h4 d-none d-md-inline mr-1"
        :class="[
          isInternalView && 'text-white',
          !isInternalView && 'text-black'
        ]"
      >
        Hi,
      </span>
      <span
        class="text-light-50 font-weight-bolder font-size-h4 d-none d-md-inline mr-3"
        :class="[
          isInternalView && 'text-white',
          !isInternalView && 'text-black'
        ]"
      >
        {{ user.firstName }} {{ user.lastName }}
      </span>
      <span class="symbol symbol-40 symbol-light-success">
        <a href="#" @click="onLogout" class="header-icon">
          <img alt="logout" :src="logoutIcon" />
        </a>
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}
</style>

<script>
// import { LOGOUT } from "@/core/store/auth.module";
import { GET_QUERY, API_CURRENT_USER_INFO } from "@/core/store/crud.module";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";
import stringFormatter from "@/core/helpers/stringFormatter";
import Mgr from "@/core/services/security.service";

export default {
  name: "KTQuickUser",
  data() {
    return {
      mgr: new Mgr(),
      initials: "",
      user: {
        firstName: "",
        lastName: "",
        profile: {}
      }
    };
  },
  props: {
    isInternalView: Boolean
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      let self = this;

      // .then(userInfo => {
      //   this.user = userInfo;
      // });
      await this.$store
        .dispatch(GET_QUERY, {
          listName: API_CURRENT_USER_INFO
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            self.user = response.data;
            if (self.user) {
              self.initials = stringFormatter.initials(
                self.user.firstName,
                self.user.lastName
              );
            } else {
              self.mgr.getUser().then(userInfo => {
                self.user = userInfo;
                self.initials = stringFormatter.initials(
                  self.user.profile.aspireRole,
                  self.user.profile.aspireRole
                );
              });
            }
          }
        });
    },
    setInitials() {
      return stringFormatter.initials(
        this.user.profile.aspireRole,
        this.user.profile.aspireRole
      );
    },
    onLogout(event) {
      event.preventDefault();

      this.mgr.signOut();
      this.$router.push({ name: "login" });
      // this.$store
      //   .dispatch(LOGOUT)
      //   .then(() => this.$router.push({ name: "login" }));
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    }
  },
  computed: {
    /**
     * Get header my account icon
     * @returns {string}
     */
    logoutIcon() {
      return (
        process.env.BASE_URL +
        (this.isInternalView
          ? "media/assets/icons/icons_logout_white.png"
          : "media/assets/icons/icons_logout.png")
      );
    }

    // initials() {
    //   // return stringFormatter.initials(this.user.firstName, this.user.lastName);
    //   return stringFormatter.initials(
    //     this.user.profile.aspireRole,
    //     this.user.profile.aspireRole
    //   );
    // }
  }
};
</script>
